var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276,
    height: 276,
    viewBox: "0 0 276 276"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5821s4w70b",
    x1: "-103.604%",
    x2: "-103.604%",
    y1: "-2.286%",
    y2: "94.79%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A039C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4D00B6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "1b78w8u29a",
    width: 275,
    height: 275,
    x: 0,
    y: 0,
    rx: 137.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wlu9461v8c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1b78w8u29a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#5821s4w70b)",
    xlinkHref: "#1b78w8u29a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M146.013 75.733l36.563 38.891 6.857-38.891h-43.42zm-60.449 0l6.857 38.891 36.563-38.891h-43.42zm17.43 39.026l29.99.002h4.516l34.504-.002-34.505-36.702-34.504 36.702zm87.612 0h35.892L196.963 78.7l-6.357 36.06zm-142.106 0h35.892L78.034 78.7 48.5 114.76zm143.233 7.864l-1.127.002-41.836 90.968 77.73-90.97h-34.767zm-98.545 0l44.311 96.644 44.31-96.644h-88.62zm-44.688.002l77.727 90.968-41.836-90.968H48.5z"
  }))))));
}
SvgInstantBonus.displayName = 'InstantBonus';
export default SvgInstantBonus;